<div class="row">
  <div class="col">
    <div [innerHTML]="element.data | safeHtml"></div>
  </div>
</div>
